/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'

import './SignUp.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import Logo from '../../assets/svg/logo.svg'

import { post } from '../../services/https'
import { useNavigate } from 'react-router-dom'

import loadingPic from '../../assets/svg/Loading.svg'

export default function index() {
  const [name, setName] = useState('')
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const [sex, setSex] = useState('مرد')
  const [alertName, setAlertName] = useState(false)
  const [alertPassword, setAlertPassword] = useState(false)
  const [alertEmail, setAlertEmail] = useState(false)

  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const signUpHanlder = (e) => {
    e.preventDefault()
    if (name.length >= 5) {
      setAlertName(false)
    } else {
      setAlertName(true)
    }

    if (password.length >= 6) {
      setAlertPassword(false)
    } else {
      setAlertPassword(true)
    }

    if (email.length >= 6 && email.includes('@')) {
      setAlertEmail(false)
    } else {
      setAlertEmail(true)
    }

    if (name.length >= 5 && password.length >= 6 && email.length >= 6 && email.includes('@') && email.includes('.')) {
      setLoading(true)
      post('/api/front/users/create', {
          phoneNumber: localStorage.getItem('phoneNumber'),
          code: parseInt(localStorage.getItem('code')),
          name,
          password,
          email,
          sex
        }, {
          'Content-Type': 'application/json'
        }).then(response => {
          if (response.data.messageFa === 'کاربری با موفقیت ساخته شد') {
            notify('success', 'ثبت نام با موفقیت انجام شد')
            setTimeout(() => {
              navigate('/login')
            }, 4000)
            localStorage.setItem('token', response.data.token)
          }
        }).catch(error => {
          setLoading(false)
          if (error.response.data.messageFa === 'کاربری با این مشخصات یافت شد') {
            notify('error', 'شما قبلاً ثبت نام کرده‌اید')
            setTimeout(() => {
              navigate('/login')
            }, 4000)
          } else if (error.response.data.messageFa === "کد صحیح نیست") {
            notify('error', error.response.data.messageFa)
            setTimeout(() => {
              navigate('/verfication')
            }, 4000)
          } else {
            notify('error', 'دریافت اطلاعات با خطا مواجه شد')
          }
        })
    } else {
      setAlertEmail(true)
    }
  }

  return (
    <div id='SignUp'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className='scroll'>
        <img src={Logo} alt='Logo' />
        <span className='title'>کانولی</span>
        <span className='subtitle'>خوش آمدید</span>
        <form action=''>
          <div className='input'>
            <label htmlFor=''>نام و نام خانوادگی :</label>
            <input onChange={e => setName(e.target.value)} type='text' name='' id='from' placeholder='نام' />
            <small style={alertName ? {} : { display: 'none' }}>نام و نام خانوادگی صحیح نیست</small>
          </div>
          <div className='input'>
            <label htmlFor=''>رمز عبور :</label>
            <input onChange={e => setPassword(e.target.value)} type='password' name='' id='from' placeholder='رمز عبور' />
            <small style={alertPassword ? {} : { display: 'none' }}>حداقل 6 کاراکتر</small>
          </div>
          <div className='input'>
            <label htmlFor=''>آدرس ایمیل :</label>
            <input onChange={e => setEmail(e.target.value)} type='text' name='' id='from' placeholder='ایمیل' />
            <small style={alertEmail ? {} : { display: 'none' }}>آدرس ایمیل صحیح نیست</small>
          </div>
          <div className='button'>
            <span className='gender'>
              <span>جنسیت :</span>
              <span className='type'>
                <span>
                  <input defaultChecked onClick={() => setSex('مرد')} type='radio' name='gender' id='gender' />
                  <label htmlFor="gender" name='gender'>آقا</label>
                </span>
                <span>
                  <input onClick={() => setSex('زن')} type='radio' name='gender' id='womenRadioButton' className='womenRadioButton'/>
                  <label htmlFor="womenRadioButton" name='womenRadioButton'>خانم</label>
                </span>
              </span>
            </span>
            <span>
              <button onClick={signUpHanlder}>
                <span style={loading ? {display: 'none'} : {}}>ثبت</span>
                <img style={loading ? {} : {display: 'none'}} className='loadingPic' src={loadingPic} alt='loadingPic' />
              </button>
            </span>
          </div>
        </form>
      </div>
      <Footer page={''} />
    </div>
  )
}
